import type React from 'react'

// Stroke icons from the prototype (ED_IC). Static path markup only.
const IC: Record<string, string> = {
  col1: '<rect x="3" y="4" width="18" height="16" rx="2"/>',
  col2: '<rect x="3" y="4" width="18" height="16" rx="2"/><path d="M12 4v16"/>',
  col3: '<rect x="3" y="4" width="18" height="16" rx="2"/><path d="M9 4v16M15 4v16"/>',
  divider: '<path d="M3 12h18"/><path d="M7 7h10M7 17h10" opacity=".35"/>',
  spacer:
    '<path d="M12 5v14M8.5 8.5L12 5l3.5 3.5M8.5 15.5L12 19l3.5-3.5"/><path d="M4 3h16M4 21h16" opacity=".35"/>',
  heading: '<path d="M6 4v16M18 4v16M6 12h12"/>',
  text: '<path d="M4 6h16M4 10h16M4 14h10M4 18h13"/>',
  image:
    '<rect x="3" y="4" width="18" height="16" rx="2"/><circle cx="8.5" cy="9.5" r="1.5"/><path d="M21 16l-5-5-9 9"/>',
  button:
    '<rect x="3" y="8" width="18" height="8" rx="4"/><path d="M8.5 12h7"/>',
  video:
    '<rect x="3" y="5" width="18" height="14" rx="2"/><path d="M10 9.5l4.5 2.5-4.5 2.5z"/>',
  table:
    '<rect x="3" y="4" width="18" height="16" rx="2"/><path d="M3 10h18M3 15h18M9 4v16"/>',
  html: '<path d="M8 8l-4 4 4 4M16 8l4 4-4 4M13.5 5.5l-3 13"/>',
  social:
    '<circle cx="6" cy="12" r="2.5"/><circle cx="18" cy="6" r="2.5"/><circle cx="18" cy="18" r="2.5"/><path d="M8.2 10.9l7.6-3.8M8.2 13.1l7.6 3.8"/>',
  header:
    '<rect x="3" y="4" width="18" height="16" rx="2"/><path d="M3 9h18M7 6.5h4"/>',
  footer:
    '<rect x="3" y="4" width="18" height="16" rx="2"/><path d="M3 15h18M7 17.5h10"/>',
  product:
    '<path d="M5 8h14l-1.2 12H6.2L5 8z"/><path d="M9 8V6.5a3 3 0 016 0V8"/>',
  coupon:
    '<path d="M3 7.5A1.5 1.5 0 014.5 6h15A1.5 1.5 0 0121 7.5V10a2 2 0 000 4v2.5a1.5 1.5 0 01-1.5 1.5h-15A1.5 1.5 0 013 16.5V14a2 2 0 000-4z"/><path d="M14 6v12" stroke-dasharray="2 2.2"/>',
  wallet:
    '<rect x="3" y="6" width="18" height="13" rx="2.5"/><path d="M3 10.5h18M15.5 14.5h2.5"/>',
  rewards:
    '<rect x="3.5" y="9" width="17" height="11" rx="1.5"/><path d="M12 9v11M3.5 13h17"/><path d="M12 9c-1.2-3-4.8-4-5.2-2S9 9 12 9zm0 0c1.2-3 4.8-4 5.2-2S15 9 12 9z"/>',
  tier: '<path d="M5 20v-5M12 20V10M19 20V4"/>',
  spark:
    '<path d="M12 3l1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9z"/><path d="M19 16l.7 1.8 1.8.7-1.8.7-.7 1.8-.7-1.8-1.8-.7 1.8-.7z"/>',
  cart: '<path d="M3 4h2l2.4 11h10.2L20 7H6.2"/><circle cx="9" cy="19.5" r="1.4"/><circle cx="17" cy="19.5" r="1.4"/>',
  clock: '<circle cx="12" cy="13" r="8"/><path d="M12 9v4l2.5 2M9.5 2.5h5"/>',
  undo: '<path d="M9 14L4 9l5-5"/><path d="M4 9h10.5a5.5 5.5 0 010 11H11"/>',
  redo: '<path d="M15 14l5-5-5-5"/><path d="M20 9H9.5a5.5 5.5 0 000 11H13"/>',
  desktop:
    '<rect x="3" y="4" width="18" height="12" rx="1.5"/><path d="M8 20h8M12 16v4"/>',
  mobile:
    '<rect x="7" y="3" width="10" height="18" rx="2"/><path d="M11 18h2"/>',
  eye: '<path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12z"/><circle cx="12" cy="12" r="3"/>',
  pencil: '<path d="M4 20h4L19 9l-4-4L4 16v4z"/><path d="M13.5 6.5l4 4"/>',
  trash: '<path d="M4 7h16M10 11v6M14 11v6M5.5 7l1 13h11l1-13M9 7V4h6v3"/>',
  copy: '<rect x="8" y="8" width="12" height="12" rx="2"/><path d="M16 8V6a2 2 0 00-2-2H6a2 2 0 00-2 2v8a2 2 0 002 2h2"/>',
  up: '<path d="M12 19V5M6 11l6-6 6 6"/>',
  down: '<path d="M12 5v14M6 13l6 6 6-6"/>',
  grip: '<circle cx="9" cy="6" r="1.2" fill="currentColor"/><circle cx="15" cy="6" r="1.2" fill="currentColor"/><circle cx="9" cy="12" r="1.2" fill="currentColor"/><circle cx="15" cy="12" r="1.2" fill="currentColor"/><circle cx="9" cy="18" r="1.2" fill="currentColor"/><circle cx="15" cy="18" r="1.2" fill="currentColor"/>',
  link: '<path d="M10 14a4 4 0 005.7 0l3-3a4 4 0 00-5.7-5.7l-1 1"/><path d="M14 10a4 4 0 00-5.7 0l-3 3a4 4 0 005.7 5.7l1-1"/>',
  list: '<path d="M9 6h11M9 12h11M9 18h11"/><circle cx="4.5" cy="6" r="1" fill="currentColor"/><circle cx="4.5" cy="12" r="1" fill="currentColor"/><circle cx="4.5" cy="18" r="1" fill="currentColor"/>',
  alL: '<path d="M4 6h16M4 10h10M4 14h16M4 18h10"/>',
  alC: '<path d="M4 6h16M7 10h10M4 14h16M7 18h10"/>',
  alR: '<path d="M4 6h16M10 10h10M4 14h16M10 18h10"/>',
  filter: '<path d="M3 5h18l-7 8v6l-4 2v-8z"/>',
  mail: '<path d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>',
  x: '<path d="M6 6l12 12M18 6L6 18"/>',
  check: '<path d="M20 6L9 17l-5-5"/>',
  plus: '<path d="M12 5v14M5 12h14"/>',
  swap: '<path d="M7 4L3 8l4 4M3 8h14M17 20l4-4-4-4M21 16H7"/>',
  split:
    '<rect x="3" y="6" width="8" height="12" rx="1.5"/><path d="M14 8h7M14 12h7M14 16h4"/>',
  sideL:
    '<rect x="3" y="7" width="7" height="10" rx="1.2"/><path d="M13 9h8M13 12h8M13 15h5"/>',
  sideR:
    '<rect x="14" y="7" width="7" height="10" rx="1.2"/><path d="M3 9h8M3 12h8M3 15h5"/>',
  clear: '<path d="M5 5h10M10 5l-3 14M14 14l6 6M20 14l-6 6"/>',
  search: '<circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/>',
  chev: '<path d="M6 9l6 6 6-6"/>',
  lock: '<rect x="5" y="11" width="14" height="10" rx="2"/><path d="M8 11V7a4 4 0 018 0v4"/>',
  ext: '<path d="M14 4h6v6M20 4l-9 9"/><path d="M18 14v5a1 1 0 01-1 1H5a1 1 0 01-1-1V7a1 1 0 011-1h5"/>',
}

// Icon per block type (panel header, chrome).
export const TYPE_ICON: Record<string, string> = {
  columns: 'col2',
  text: 'text',
  image: 'image',
  split: 'split',
  button: 'button',
  divider: 'divider',
  spacer: 'spacer',
  table: 'table',
  social: 'social',
  header: 'header',
  footer: 'footer',
  product: 'product',
  coupon: 'coupon',
  wallet: 'wallet',
  cart: 'cart',
  tierbar: 'tier',
  rewards: 'rewards',
  countdown: 'clock',
  video: 'video',
  html: 'html',
}

export const Icon: React.FC<{ name: string; className?: string }> = ({
  name,
  className,
}) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.8}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    // Static, hard-coded path markup (never user input).
    dangerouslySetInnerHTML={{ __html: IC[name] ?? '' }}
  />
)
